import React, { useEffect } from 'react'
import {
   FileIcon,
   FromSection,
   FundraiserTitle,
   ImageUpload,
   PersonalFundraisersEdit,
   SubTitle
} from './myPersonalFundraisersStyle';
import { Button, Col, Image, Row, Form } from 'react-bootstrap'
import FileUploadIcon from '../../../assests/images/bold-gallery.svg';
import { MESSAGE } from '../../../utils/message';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { fundRaiserDetailHandler, fundRaiserDetailAction } from '../../../redux/slices/myAccount/fundRaiserDetail-slice';
import { useDispatch, useSelector } from 'react-redux';
import { PersonalFundraiserEditFormikProps } from '../../../utils/types';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import noImage from "../../../assests/images/gnp_noimg.png"
import { createFundraiserHandler, editFundraiserHandler } from '../../../redux/slices/myAccount/manageFundraiser-slice';

const PersonalFundraiserEdit = () => {
   const { user_id, review_id, org_id } = useParams()
  

   const { state, pathname } = useLocation()
   const navigate = useNavigate()
   const fundRaiserDetail = useSelector((state: any) => state?.fundRaiserDetail?.data?.results)
  
   
   const dispatch: any = useDispatch();

   useEffect(() => {
      if (pathname.includes("edit") && user_id && org_id) {
         dispatch(fundRaiserDetailHandler(user_id, org_id))
      } else {
         dispatch(fundRaiserDetailAction.fundRaiserDetailSliceReset())
      }
      window.scrollTo(0, 0);
   }, [])

   const handleSubmit = (e: any) => {
      e.preventDefault();
   };


   const formik = useFormik<PersonalFundraiserEditFormikProps>({
      initialValues: {
         image: fundRaiserDetail ? fundRaiserDetail.image : "",
         title: fundRaiserDetail ? fundRaiserDetail.title : "",
         goal: fundRaiserDetail ? fundRaiserDetail.goal : "",
         end_date: fundRaiserDetail ? fundRaiserDetail.end_date : "",
         story: fundRaiserDetail ? fundRaiserDetail.story : "",
         org_id: fundRaiserDetail? fundRaiserDetail?.org_id : org_id 

      },
      enableReinitialize: true,
      validationSchema: Yup.object({
         image: Yup.mixed()
            .required(MESSAGE.requiredErrors("Photo"))
            .test(
               "fileFormat",
               "Unsupported file format. Only images are allowed.",
               (value: any) => {
                  if (typeof value === "string") {
                     return true;
                  }

                  return value && ["image/jpeg", "image/png", "image/gif"].includes(value.type);
               }
            ),
         // image: Yup.mixed().required(MESSAGE.requiredErrors("Photo")),
         title: Yup.string().trim().required(MESSAGE.requiredErrors("Title")),
         goal: Yup.number().min(1, MESSAGE.minDigitErrors("Goal", 1)).max(1000000, MESSAGE.maxDigitErrors("Goal", 1000000)).typeError("Goal must be a number").required(MESSAGE.requiredErrors("Goal")),
         // end_date: Yup.date().required(MESSAGE.requiredErrors("End date")),
         end_date: Yup.date()

            .required(MESSAGE.requiredErrors("End date"))
            .test(
               "notPastDate",
               "End date cannot be in the past.",
               (value) => {
                  return moment(value).isSameOrAfter(moment(), "day"); // Ensure the date is today or in the future
               }
            ),
         story: Yup.string()
            .trim()
            .max(500, MESSAGE.maxDigitErrors("Story", 500)) // Ensure the function provides the correct message
            .required(MESSAGE.requiredErrors("Story"))
      }),
      onSubmit: (values: PersonalFundraiserEditFormikProps) => {
         console.log(review_id,"review_id");
         
         const formData: any = new FormData();
         if (typeof values.image === "object") {
            formData.append("image", values.image);
         }
         formData.append("title", values.title);
         formData.append("goal", values.goal.toString());
         formData.append("end_date", values.end_date);
         formData.append("story", values.story);
         formData.append("org_id", values.org_id);
         formData.append("review_id", review_id);
         // if (user_id) {
         //    if (pathname.includes("edit")) {
         //       if (org_id && review_id) {
         //          const tempValues = { ...values, review_id, formData }
         //          //delete tempValues["image"]
         //          dispatch(editFundraiserHandler(user_id, org_id, formData))
         //       }
         //    } else if (org_id && review_id) {
         //       const tempValues = { ...values, org_id, review_id, formData }
         //       dispatch(createFundraiserHandler(user_id, formData))
         //    }
         //    navigate(`/users/profile/${user_id}/fundraisers/list`)
         // }
         if (user_id) {
            if (pathname.includes("edit")) {
               if (org_id && review_id) {

                  const tempValues = { ...values, review_id, formData };

                  dispatch(editFundraiserHandler(user_id, org_id, formData))
                     .then(() => {
                        // Navigate after successful response
                        navigate(`/users/profile/${user_id}/fundraisers/list`);
                     })
                     .catch((error: any) => {

                        // Handle error (e.g., show a toast message)
                        console.error("Failed to edit fundraiser:", error);
                     });
               }
            } else if (org_id && review_id) {

               dispatch(createFundraiserHandler(user_id, formData))
                  .then(() => {
                     // Navigate after successful response
                     navigate(`/users/profile/${user_id}/fundraisers/list`);
                  })
                  .catch((error: any) => {
                     // Handle error (e.g., show a toast message)
                     console.error("Failed to create fundraiser:", error);
                  });
            }
         }


      },
   });
   const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.currentTarget.files && event.currentTarget.files[0];
      formik.setFieldValue("image", file);

   };



   //   const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
   //    const files = event.target.files;
   //     if (files && files.length > 0) {
   //       const file = files[0];
   //       formik.setFieldValue("image", file);
   //     }
   //  };

   return (
      <PersonalFundraisersEdit>
         <FundraiserTitle>{state?.org_name}</FundraiserTitle>
         <SubTitle>{MESSAGE.reviewFundraiserText}</SubTitle>
         <FromSection>
            <Form onSubmit={handleSubmit}>
               <Row>
                  <Col md={12}>
                     <Form.Group className="profile-upload" controlId="formFile">
                        <label htmlFor="filePicker" className="add-photo">
                           <FileIcon>
                              <Image src={FileUploadIcon} alt="Upload Icon" className="upload-icon" />
                           </FileIcon>
                           {MESSAGE.addPhoto}
                        </label>

                        <Form.Control
                           className="upload-img"
                           id="filePicker"
                           type="file"
                           name="image"
                           onChange={handleImageChange}
                           onBlur={formik.handleBlur}
                        />

                        <ImageUpload>
                           <Image
                              src={
                                 formik.errors.image || !formik.values.image
                                    ? noImage
                                    : typeof formik.values.image === "object"
                                       ? URL.createObjectURL(formik.values.image)
                                       : formik.values.image
                              }
                           />
                        </ImageUpload>

                        {formik.touched.image && formik.errors.image && (
                           <div className="error">
                              <p>{formik.errors.image}</p>
                           </div>
                        )}
                     </Form.Group>
                  </Col>
                  <Col md={6}>
                     <Form.Group controlId="formBasicTitle" className="input-box">
                        <Form.Label>{MESSAGE.title}</Form.Label>
                        <Form.Control type="text" name="title" value={formik.values.title} onChange={formik.handleChange} />

                     </Form.Group>
                     {formik.touched.title && formik.errors.title && (
                        <div className="error">
                           <p>{formik.errors.title}</p>
                        </div>
                     )}
                  </Col>
                  <Col md={6}>
                     <Form.Group controlId="formBasicGoal" className="input-box">
                        <Form.Label>{MESSAGE.myGoal}</Form.Label>
                        <Form.Control
                           type="text"
                           name="goal"
                           value={formik.values.goal}
                           onChange={(e) => {
                              const value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                              formik.setFieldValue("goal", value); // Update formik state
                           }}
                           onKeyDown={(e) => {
                              // Prevent invalid key inputs
                              if (["e", "E", "+", "-", "."].includes(e.key)) {
                                 e.preventDefault();
                              }
                           }}
                        // onChange={formik.handleChange}
                        // onKeyDown={(e) => {
                        //    if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-' || e.key === '.') {
                        //       e.preventDefault();
                        //    }
                        // }}
                        />
                     </Form.Group>
                     {formik.touched.goal && formik.errors.goal && (
                        <div className="error">
                           <p>{formik.errors.goal}</p>
                        </div>
                     )}
                  </Col>
                  <Col md={6}>
                     <Form.Group controlId="formBasicEndDate" className="input-box">
                        <Form.Label>{MESSAGE.endDate}</Form.Label>
                        <Form.Control type="date" name="end_date" value={formik.values.end_date} onChange={formik.handleChange} />
                     </Form.Group>
                     {formik.touched.end_date && formik.errors.end_date && (
                        <div className="error">
                           <p>{formik.errors.end_date}</p>
                        </div>
                     )}
                  </Col>
                  <Col md={12}>
                     <Form.Group controlId="formBasicStory" className="input-box">
                        <Form.Label>{MESSAGE.story}</Form.Label>
                        <Form.Control as="textarea" name="story" type="text" value={formik.values.story} onChange={formik.handleChange} onBlur={formik.handleBlur} />
                     </Form.Group>
                     {formik.touched.story && formik.errors.story && (
                        <div className="error">
                           <p>{formik.errors.story}</p>
                        </div>
                     )}

                  </Col>
               </Row>
            </Form>
         </FromSection>
         <Button className="btn-outline-success-blue" onClick={() => formik.handleSubmit()}>Save Fundraiser</Button>
      </PersonalFundraisersEdit>
   )
}

export default PersonalFundraiserEdit
